import { StaticImageData } from "next/image";
import { ReactElement } from "react";
import { Button } from "./client.button";

export type ModelFinderOption = {
	image: StaticImageData | string;
	title: string;
	details: string;
	price: string | null;
	value: string;
	showIfNoPrice?: boolean;
};

interface Props {
	options: ModelFinderOption[];
	selected: string[];
	setSelected: Function;
	optionClasses: string;
	imageElement: (
		image: ModelFinderOption["image"],
		alt: string,
	) => ReactElement;
}

export default function ModelFinderOptions({
	options,
	selected,
	setSelected,
	optionClasses,
	imageElement,
}: Props) {
	return (
		<div className="my-8 flex flex-wrap justify-center gap-4">
			{options
				.filter((option) => option.price || option.showIfNoPrice)
				.map((option) => {
					return (
						<Button
							buttonStyle="none"
							buttonSize="none"
							key={option.title}
							toggleable
							isPressed={selected.includes(option.value)}
							onClick={() => setSelected(option.value)}
							overrideClassName
							className={`${optionClasses} flex w-full items-center gap-2 rounded-xl border-2 border-white bg-white p-4 hover:border-primary-100 aria-pressed:border-primary-500 aria-pressed:shadow-lg md:p-6`}
						>
							{option.image ? (
								<div className="flex items-center justify-center">
									{imageElement(option.image, option.title)}
								</div>
							) : null}
							<div>
								<h2 className="text-headline-4 text-primary-800">
									{option.title}
								</h2>
								{option.price ? (
									<div className="text-caption">
										Starting in the {option.price}s.
									</div>
								) : null}
								<div className="text-xs text-gray-600">{option.details}</div>
							</div>
						</Button>
					);
				})}
		</div>
	);
}
